// src/pages/DevHub/components/DevStatusPill.tsx
// Replaces: .dev-status-pill + .succeeded/.success, .pending/.processing/.warning, .error/.failed/.declined

import React from 'react';
import { cn } from '../../../lib/utils';

export type DevStatusVariant =
    | 'success'
    | 'succeeded'
    | 'pending'
    | 'processing'
    | 'warning'
    | 'error'
    | 'failed'
    | 'declined';

interface DevStatusPillProps {
    status: DevStatusVariant;
    children: React.ReactNode;
    className?: string;
}

/*
 * .dev-status-pill (base):
 *   font-size: 11px;
 *   font-weight: 700;
 *   padding: 2px 8px;
 *   border-radius: 4px;
 *   text-transform: uppercase;
 *
 * .dev-status-pill.succeeded, .dev-status-pill.success:
 *   background: #e6f4ea; color: #1e8e3e;
 *
 * .dev-status-pill.pending, .dev-status-pill.processing, .dev-status-pill.warning:
 *   background: #fef7e0; color: #f9ab00;
 *
 * .dev-status-pill.error, .dev-status-pill.failed, .dev-status-pill.declined:
 *   background: #fce8e6; color: #d93025;
 */
const statusVariantClasses: Record<DevStatusVariant, string> = {
    success: 'bg-[#e6f4ea] text-[#1e8e3e]',
    succeeded: 'bg-[#e6f4ea] text-[#1e8e3e]',
    pending: 'bg-[#fef7e0] text-[#f9ab00]',
    processing: 'bg-[#fef7e0] text-[#f9ab00]',
    warning: 'bg-[#fef7e0] text-[#f9ab00]',
    error: 'bg-[#fce8e6] text-[#d93025]',
    failed: 'bg-[#fce8e6] text-[#d93025]',
    declined: 'bg-[#fce8e6] text-[#d93025]',
};

const DevStatusPill: React.FC<DevStatusPillProps> = ({ status, children, className }) => (
    <span className={cn(
        'text-[11px] font-bold px-[8px] py-[2px] rounded-[4px] uppercase',
        statusVariantClasses[status],
        className,
    )}>
        {children}
    </span>
);

export default DevStatusPill;
